import React, { ElementType, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { FolderType } from '@/api/generated';
import CachedLocationDisplay from '@/components/fields/Location/CachedLocationDisplay';

interface CreateOrganizationItemModalHeaderProps {
  Icon?: ElementType;
  title?: string;
  locationSlug?: string | null;
  organizationSlug?: string;
  type?: FolderType;
}

const CreateOrganizationItemModalHeader: FC<CreateOrganizationItemModalHeaderProps> = ({
  Icon,
  title,
  organizationSlug,
  locationSlug,
  type
}) => {
  const { t } = useTranslation('organizations');
  const { watch } = useFormContext();
  const name = watch('name');

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      sx={{
        px: 0,
        pt: 2,
        pb: 2,
        '& .HeaderIcon-root': {
          width: 52,
          height: 52
        }
      }}
    >
      {Icon && <Icon className="HeaderIcon-root" />}
      <Stack>
        <Typography variant="h3" sx={{ fontWeight: 600 }}>
          {t('layouts.organizations.create.create')}
          &nbsp;
          {title}
        </Typography>
        <CachedLocationDisplay
          organizationSlug={organizationSlug}
          locationSlug={locationSlug!}
          newItem={{
            type: type!,
            name,
            slug: ''
          }}
          useInsideDialog
          outlined
        />
      </Stack>
    </Stack>
  );
};

export default CreateOrganizationItemModalHeader;
